import React, { useEffect, useRef } from 'react';
import { Splide, SplideSlide } from "@splidejs/react-splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";
import CommonUtil from '../../../../utils/commonUtil';
import CTA from '../../Content/MarketingSectionContainer/global/CTA';
import { Card } from './GenericCarousel';

const channel = CommonUtil.getChannel();
const isWap = channel === 'wap';




const DraggableCarousel = ({ component, state, ...rest }) => {

  const breakpoint_map = {
    desktop: 1024,
    tablet: 600,
    mobile: 480,
  };

  const splideRef = useRef(null);

  const forcePlay = () => {
    const autoScroll = splideRef.current?.splide?.Components?.AutoScroll;
    if (autoScroll) autoScroll.play();
  };


  useEffect(() => {
    const playAutoScroll = () => {
      const autoScroll = splideRef.current?.splide?.Components?.AutoScroll;
      if (!autoScroll) return;
      autoScroll.play();
    };

    const handleVisibility = () => {
      if (document.visibilityState === 'visible') playAutoScroll();
    };

    window.addEventListener('pageshow', playAutoScroll);
    document.addEventListener('visibilitychange', handleVisibility);

    return () => {
      window.removeEventListener('pageshow', playAutoScroll);
      document.removeEventListener('visibilitychange', handleVisibility);
    };
  }, []);


  const splideSettings = {
    responsive: component?.carousel_settings.responsive.map((r) => {
      const { device, ...rest } = r;
      return {
        breakpoint: breakpoint_map[r.device],
        settings: rest,
      };
    }),
  };

  const defaultSettings = splideSettings.responsive.find(
    (r) => r.breakpoint === 1024,
  )?.settings;

  const splideOptions = {
    ...defaultSettings,
    autoScroll: {
      ...defaultSettings?.autoscroll?.[0],
      pauseOnHover: defaultSettings?.autoscroll?.[0]?.pauseonhover,
      pauseOnFocus: defaultSettings?.autoscroll?.[0]?.pauseonfocus
    },
  };


  return (
    <div
      className={`section-wrapper section-padding horizontal-Carousel draggable-carousel ${component?.carousel_display_template || 'carousel-template-generic'}`}
    >
      <div className='section-title'>
        {component?.title && <h5>{component?.title}</h5>}
        {component?.sub_title && (
          <p
            className={
              state?.user?.data?.result?.isLoggedIn &&
                component?.carousel_display_template !== 'carousel-template-3'
                ? 'logged-user-wap'
                : ''
            }
          >
            {component?.sub_title}
          </p>
        )}
      </div>
      {component?.description && (
        <p className='section5-text'>{component?.description}</p>
      )}
      <div
        className='wrapper'
        style={{ backgroundColor: component?.background_color }}
      >
        <div className={`carousel gift-icon-slider`}>
          <Splide
            options={splideOptions}
            key={window.location.pathname}
            extensions={{ AutoScroll }}
            aria-label={component?.title}
            ref={splideRef}
            onMounted={(splide) => {
              const autoScroll = splide.Components?.AutoScroll;
              if (autoScroll) autoScroll.play();
            }}
            onDragged={() => forcePlay()}
            onMoved={() => forcePlay()}
          >
            {component?.carousel_cards?.map((card, index) => (
              <SplideSlide key={index}>
                <CTA cta={{ ...card.cta }} isLink='true'>
                  <Card card={card} index={index} svg={isWap} />
                </CTA>
              </SplideSlide>
            ))}
          </Splide>
        </div>
      </div>
    </div>
  );
};


export default DraggableCarousel;
